import {
  type WorkplaceProfileResponse,
  workplaceProfileResponseSchema,
  workplaceProfileUpdateSchema,
} from "@clipboard-health/contract-backend-main";
import { patch } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

interface UpdatePreShiftOrientationParams {
  workplaceId: string;
  preShiftOrientation: {
    enabled: boolean;
    orientationLengthInMinutes?: number;
    qualifications?: string[];
  };
}

export function useUpdatePreShiftOrientation(
  options: UseMutationOptions<
    WorkplaceProfileResponse,
    unknown,
    UpdatePreShiftOrientationParams
  > = {}
) {
  return useMutation({
    mutationFn: async ({ workplaceId, preShiftOrientation }) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}`,
        data: {
          data: {
            id: workplaceId,
            type: "workplace",
            attributes: { preShiftOrientation },
          },
        },
        bodySchema: workplaceProfileUpdateSchema,
        responseSchema: workplaceProfileResponseSchema,
      });
      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.UPDATE_PRE_SHIFT_ORIENTATION_FAILURE,
    },
    ...options,
  });
}
